import { createContext, useContext } from 'react'
import { Maybe } from 'types/graphqlTypes'
import { CarrierPageQueryResult } from '../components/Carrier/graphql/CarrierPage'
import { ICarrierPageFragment } from '../components/Carrier/graphql/CarrierPageFragment'

export interface ICarrierProfileContextValue {
  carrierApplication: Maybe<ICarrierPageFragment>
  loading: CarrierPageQueryResult['loading']
  error: CarrierPageQueryResult['error']
}

export const CarrierProfileContext = createContext<ICarrierProfileContextValue>({
  loading: false,
} as ICarrierProfileContextValue)

export const useCarrierProfileContext = (): ICarrierProfileContextValue =>
  useContext(CarrierProfileContext)
